import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { SimpleTableCard } from "@/partner/shared/components/SimpleTableCard";
import { formatNumber } from "@/shared/utils/formatNumber";
import { useAnalyticsUsersByLinkQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsUsersByLinkTable: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();
  const [limit, setLimit] = useState(10);

  const { data, loading, error } = useAnalyticsUsersByLinkQuery({
    variables: { filter: filter as never, limit },
  });

  const rows = (data?.analyticsUsers.usersByLink ?? []).map((row) => [
    row.title,
    formatNumber(row.users),
  ]);

  return (
    <SimpleTableCard
      title={t("analytics.users.tableByLink")}
      columns={[
        { name: t("analytics.users.columnLink"), minWidth: 200 },
        { name: t("analytics.users.columnUsers") },
      ]}
      rows={rows}
      loading={loading}
      error={error}
      limit={limit}
      setLimit={setLimit}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.UsersByLinkType}
          filter={filter}
        />
      }
    />
  );
};
